module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_moere_og_romsdal_neg.71893bb5.svg";